'use client';

import { useRouter } from 'next/router';
import { useCreateRegionFilters } from '@/creditflowresearch/application/PageFilters/hooks/create';
import type { IFilterSet } from '@/creditflowresearch/ui/common/hooks/filters/useFilterButtons';
import { transformToFilterSets } from './helpers/transformToFilterSets';

export const useAbsRegionsFilters = (): IFilterSet[] => {
  const router = useRouter();
  const { query } = router;
  const regions = useCreateRegionFilters();

  return transformToFilterSets([
    {
      key: 'regions',
      items: regions,
    },
  ], query);
};
